import Loadable from "react-loadable";
import Loader from "components/shared/loader/loader";
import { IRoute } from "shared/interface/types";
import { Category } from "container/auto/planSetup/b2c/shelfPlans/constant";

const parentBreadCrumbs = [
  { title: "menu_sidebar_auto" },
  { title: "menu_sidebar_auto_plan_setup" },
  { title: "menu_sidebar_auto_plan_setup_b2c" },
  { title: "menu_sidebar_auto_plan_setup_b2c_shelf_plans", link: "/auto/plan-setup/b2c/shelf-plans" }
];

const ShelfPlanListing = Loadable({
  loader: () => import("container/auto/planSetup/b2c/shelfPlans/listing"),
  loading() {
    return <Loader />;
  }
});
const ShelfPlanAdd = Loadable({
  loader: () => import("container/auto/planSetup/b2c/shelfPlans"),
  loading() {
    return <Loader />;
  }
});

export const AutoShelfPlanB2CRoutes: IRoute[] = [
  {
    path: "/auto/plan-setup/b2c/shelf-plans",
    element: <ShelfPlanListing category={Category.B2C} />,
    handle: {
      crumbs: parentBreadCrumbs
    }
  },
  {
    path: "/auto/plan-setup/b2c/shelf-plans/details/:id?",
    element: <ShelfPlanAdd category={Category.B2C} />,
    handle: {
      crumbs: [...parentBreadCrumbs]
    }
  }
];
